import { useContext, useEffect, useState } from "react"
import { getData } from "src/actions/getData";
import PageHeader from "src/components/PageHeader";
import shopContext from "src/context/shopContext";
import { numberWithCommas } from "src/utils/thousandSeprator";
import { TbMapDiscount } from "react-icons/tb";
import { TbShoppingCartDiscount } from "react-icons/tb";
import { TbReload } from "react-icons/tb";
import { MdAccessTime } from "react-icons/md";
import { MdOutlineDiscount } from "react-icons/md";
import { LiaMoneyBillWaveSolid } from "react-icons/lia";
import { LiaShippingFastSolid } from "react-icons/lia";
import Skeleton from "react-loading-skeleton";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

import moment from 'jalali-moment';
import WhiteBoard from "src/components/WhiteBoard";
import FilterBox from "src/components/FilterBox";
import DatePicker from "react-multi-date-picker";
import { persianToEnglishDigitConverter } from "src/utils/persianToEnglishDigitConverter";
import Hintbox from "src/components/Hintbox";
import { TbHelpSquareRounded } from "react-icons/tb";
import Accordion from "src/components/Accordion";

export default function FinancialReport() {

    const [netTotalSales, setNetTotalSales] = useState()
    const [netTotalSalesWithTax, setNetTotalSalesWithTax] = useState()
    const [totalTax, setTotalTax] = useState()
    const [goodsTotalDiscount, setGoodsTotalDiscount] = useState()
    const [couponTotalDiscount, setCouponTotalDiscount] = useState()
    const [amortizedPaidShipping, setAmortizedPaidShipping] = useState()

    const [amortizedDiscountShipping, setAmortizedDiscountShipping] = useState()
    const [timePeriod, setTimePeriod] = useState()

    const { sales, setSales } = useContext(shopContext)

    useEffect(() => {
        const controller = new AbortController(); // برای لغو درخواست
        const signal = controller.signal;

        if (!sales) {
            getData(setSales, "/sales", {}, signal);
        }

        return () => {
            controller.abort();
        };
    }, [])


    useEffect(() => {
        let cloneSales = sales;
        if (cloneSales && timePeriod) {
            cloneSales = cloneSales?.filter(cloneSale => {
                let datePaid = Date.parse(cloneSale.date_paid);
                let from = Date.parse(moment
                    .from(timePeriod[0] ? timePeriod[0] : moment().subtract(5, "years").locale('fa').format('YYYY/MM/DD'), "fa", "YYYY/MM/DD").locale("en"))
                let to = Date.parse(moment
                    .from(timePeriod[1] ? timePeriod[1] : moment().locale('fa').format('YYYY/MM/DD'), "fa", "YYYY/MM/DD").locale("en")?.add("1", "days"))
                if (datePaid > from && datePaid <= to) {
                    return cloneSale
                }
            })
        }

        let netTotalSales = 0
        cloneSales && cloneSales.forEach(sale => {
            netTotalSales += (sale.taxFreeBasePrice * sale.quantity) - sale.financialTotalDiscount + sale.addition
        });
        setNetTotalSales(netTotalSales)

        let goodsTotalDiscount = 0
        cloneSales && cloneSales.forEach(sale => {
            goodsTotalDiscount += (sale.basePrice - sale.price) * sale.quantity
        });
        setGoodsTotalDiscount(goodsTotalDiscount)

        let couponTotalDiscount = 0
        cloneSales && cloneSales.forEach(sale => {
            couponTotalDiscount += (sale.price - sale.amortizedPrice) * sale.quantity
        });
        setCouponTotalDiscount(couponTotalDiscount)

        let amortizedPaidShipping = 0
        cloneSales && cloneSales.forEach(sale => {
            amortizedPaidShipping += sale.amortizedPaidShipping
        });
        setAmortizedPaidShipping(amortizedPaidShipping)

        let amortizedDiscountShipping = 0
        cloneSales && cloneSales.forEach(sale => {
            amortizedDiscountShipping += sale.amortizedDiscountShipping
        });
        setAmortizedDiscountShipping(amortizedDiscountShipping)

        let netTotalSalesWithTax = 0
        cloneSales && cloneSales.forEach(sale => {
            netTotalSalesWithTax += (sale.taxFreeBasePrice * sale.quantity) - sale.financialTotalDiscount + sale.addition + sale.totalNetTax
        });
        setNetTotalSalesWithTax(netTotalSalesWithTax)

        let totalTax = 0
        cloneSales && cloneSales.forEach(sale => {
            totalTax += sale.totalNetTax
        });
        setTotalTax(totalTax)
    }, [sales, timePeriod])



    return (
        <>
            <PageHeader
                title="گزارش فروش‌ها"
            // btnTitle="بروزرسانی"
            // handleClick={() => {
            //     setSales();
            //     getData(setSales, "/sales");
            // }}
            // btnIcon={<TbReload className="ml-1" size="20" />}
            // isBtnLoading={!sales}
            />

            <Accordion title="نکات راهنما" icon={<TbHelpSquareRounded className="text-gray-400" />} hasVerticalLine={true} >
                <Hintbox text="سفارشات در حال انجام در این محاسبات لحاظ نشده اند و مبالغ محاسبه شده بر مبنا نحوه محاسبه ارزش افزوده و فروش در سپیدار هستند و از جدول لیست فروش‌ها در بخش مدیریت مالی دریافت می‌شوند." type="info" />
            </Accordion>

            <WhiteBoard className="!gap-5">
                <div className="flex gap-2 flex-col md:flex-row justify-between items-center">
                    {
                        sales
                            ?
                            <div className="text-lg">
                                <span className="text-gray-400">امروز،</span>
                                <span className="mx-1">{moment().locale('fa').format('dddd YYYY/MM/DD')}</span>
                            </div>
                            :
                            <Skeleton width={200} height={40} className="!rounded-xl" />
                    }
                    {
                        sales
                            ?
                            <FilterBox width={350} title={<span className="flex gap-1 items-center"><MdAccessTime size={20} />بازه زمانی:</span>} value={`از ${timePeriod?.[0] ? timePeriod?.[0] : "ابتدا"} تا ${timePeriod?.[1] ? timePeriod?.[1] : "کنون"}`}>
                                <div className="flex flex-col gap-2">
                                    <DatePicker
                                        style={{
                                            width: "100%",
                                            height: "36px",
                                            borderRadius: "10px",
                                            border: "1px solid #e5e7eb",
                                        }}
                                        placeholder={"از تاریخ ..."}
                                        onChange={(value) => {
                                            setTimePeriod((old) => [
                                                persianToEnglishDigitConverter(value?.format("YYYY/MM/DD")),
                                                old?.[1],
                                            ]);
                                            // setFilterValue((old) => [
                                            //     persianToEnglishDigitConverter(value?.format("YYYY/MM/DD")),
                                            //     old?.[1],
                                            // ]);
                                        }}
                                        calendar={persian}
                                        locale={persian_fa}
                                        format="YYYY/MM/DD"
                                        className="rmdp-mobile"
                                    />
                                    <DatePicker
                                        style={{
                                            width: "100%",
                                            height: "36px",
                                            borderRadius: "10px",
                                            border: "1px solid #e5e7eb",
                                        }}
                                        placeholder={"تا تاریخ ..."}
                                        onChange={(value) => {
                                            setTimePeriod((old) => [
                                                old?.[0],
                                                persianToEnglishDigitConverter(value?.format("YYYY/MM/DD")),
                                            ]);
                                            // setFilterValue((old) => [
                                            //     persianToEnglishDigitConverter(value?.format("YYYY/MM/DD")),
                                            //     old?.[1],
                                            // ]);
                                        }}
                                        calendar={persian}
                                        locale={persian_fa}
                                        format="YYYY/MM/DD"
                                        className="rmdp-mobile"
                                    />
                                </div>
                            </FilterBox>
                            :
                            <Skeleton width={350} height={40} className="!rounded-xl" />
                    }

                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 mb-4">
                    {
                        sales
                            ?
                            <div className="bg-white dark:bg-black rounded-xl border border-gray-100">
                                <div className="p-4 flex gap-2 border-b-solid border-b-gray-100 border-b-2">
                                    <div className="bg-gray-50 rounded-full w-14 h-14 flex justify-center items-center">
                                        <LiaMoneyBillWaveSolid className="text-primary-color" />
                                    </div>
                                    <div className="flex flex-col gap-1">
                                        <span className="font-bold text-lg">{netTotalSalesWithTax && numberWithCommas(netTotalSalesWithTax)} ریال</span>
                                        <span className="text-sm text-gray-400">مبلغ فروش (با مالیات)</span>
                                    </div>
                                </div>
                                <div className="p-4 flex gap-2">
                                    <div className="flex items-center text-sm justify-between w-full">
                                        <span className="text-gray-400">تاریخ:</span>
                                        <span>{`از ${timePeriod?.[0] ? timePeriod?.[0] : "ابتدا"} تا ${timePeriod?.[1] ? timePeriod?.[1] : "کنون"}`}</span>
                                    </div>
                                </div>
                            </div>
                            :
                            <Skeleton height={144} className="!rounded-xl" />
                    }
                    {
                        sales
                            ?
                            <div className="bg-white dark:bg-black rounded-xl border border-gray-100">
                                <div className="p-4 flex gap-2 border-b-solid border-b-gray-100 border-b-2">
                                    <div className="bg-gray-50 rounded-full w-14 h-14 flex justify-center items-center">
                                        <LiaMoneyBillWaveSolid className="text-primary-color" />
                                    </div>
                                    <div className="flex flex-col gap-1">
                                        <span className="font-bold text-lg">{netTotalSales && numberWithCommas(netTotalSales)} ریال</span>
                                        <span className="text-sm text-gray-400">مبلغ خالص فروش (بدون مالیات)</span>
                                    </div>
                                </div>
                                <div className="p-4 flex gap-2">
                                    <div className="flex items-center text-sm justify-between w-full">
                                        <span className="text-gray-400">تاریخ:</span>
                                        <span>{`از ${timePeriod?.[0] ? timePeriod?.[0] : "ابتدا"} تا ${timePeriod?.[1] ? timePeriod?.[1] : "کنون"}`}</span>
                                    </div>
                                </div>
                            </div>
                            :
                            <Skeleton height={144} className="!rounded-xl" />
                    }
                    {
                        sales
                            ?
                            <div className="bg-white dark:bg-black rounded-xl border border-gray-100">
                                <div className="p-4 flex gap-2 border-b-solid border-b-gray-100 border-b-2">
                                    <div className="bg-gray-50 rounded-full w-14 h-14 flex justify-center items-center">
                                        <LiaMoneyBillWaveSolid className="text-primary-color" />
                                    </div>
                                    <div className="flex flex-col gap-1">
                                        <span className="font-bold text-lg">{totalTax && numberWithCommas(totalTax)} ریال</span>
                                        <span className="text-sm text-gray-400">مبلغ کل مالیات بر ارزش افزوده</span>
                                    </div>
                                </div>
                                <div className="p-4 flex gap-2">
                                    <div className="flex items-center text-sm justify-between w-full">
                                        <span className="text-gray-400">تاریخ:</span>
                                        <span>{`از ${timePeriod?.[0] ? timePeriod?.[0] : "ابتدا"} تا ${timePeriod?.[1] ? timePeriod?.[1] : "کنون"}`}</span>
                                    </div>
                                </div>
                            </div>
                            :
                            <Skeleton height={144} className="!rounded-xl" />
                    }

                    {
                        sales
                            ?
                            <div className="bg-white dark:bg-black rounded-xl border border-gray-100">
                                <div className="p-4 flex gap-2 border-b-solid border-b-gray-100 border-b-2">
                                    <div className="bg-gray-50 rounded-full w-14 h-14 flex justify-center items-center">
                                        <MdOutlineDiscount className="text-primary-color" />
                                    </div>
                                    <div className="flex flex-col gap-1">
                                        <span className="font-bold text-lg">{goodsTotalDiscount && numberWithCommas(goodsTotalDiscount)} ریال</span>
                                        <span className="text-sm text-gray-400">مبلغ کل تخفیف قیمت ویژه</span>
                                    </div>
                                </div>
                                <div className="p-4 flex gap-2">
                                    <div className="flex items-center text-sm justify-between w-full">
                                        <span className="text-gray-400">تاریخ:</span>
                                        <span>{`از ${timePeriod?.[0] ? timePeriod?.[0] : "ابتدا"} تا ${timePeriod?.[1] ? timePeriod?.[1] : "کنون"}`}</span>
                                    </div>
                                </div>
                            </div>
                            :
                            <Skeleton height={144} className="!rounded-xl" />
                    }
                    {
                        sales
                            ?
                            <div className="bg-white dark:bg-black rounded-xl border border-gray-100">
                                <div className="p-4 flex gap-2 border-b-solid border-b-gray-100 border-b-2">
                                    <div className="bg-gray-50 rounded-full w-14 h-14 flex justify-center items-center">
                                        <TbShoppingCartDiscount className="text-primary-color" />
                                    </div>
                                    <div className="flex flex-col gap-1">
                                        <span className="font-bold text-lg">{couponTotalDiscount && numberWithCommas(couponTotalDiscount)} ریال</span>
                                        <span className="text-sm text-gray-400">مبلغ کل تخفیف کوپن‌ها</span>
                                    </div>
                                </div>
                                <div className="p-4 flex gap-2">
                                    <div className="flex items-center text-sm justify-between w-full">
                                        <span className="text-gray-400">تاریخ:</span>
                                        <span>{`از ${timePeriod?.[0] ? timePeriod?.[0] : "ابتدا"} تا ${timePeriod?.[1] ? timePeriod?.[1] : "کنون"}`}</span>
                                    </div>
                                </div>
                            </div>
                            :
                            <Skeleton height={144} className="!rounded-xl" />
                    }

                    {
                        sales
                            ?
                            <div className="bg-white dark:bg-black rounded-xl border border-gray-100">
                                <div className="p-4 flex gap-2 border-b-solid border-b-gray-100 border-b-2">
                                    <div className="bg-gray-50 rounded-full w-14 h-14 flex justify-center items-center">
                                        <LiaShippingFastSolid className="text-primary-color" />
                                    </div>
                                    <div className="flex flex-col gap-1">
                                        <span className="font-bold text-lg">{amortizedPaidShipping && numberWithCommas(amortizedPaidShipping)} ریال</span>
                                        <span className="text-sm text-gray-400">مبلغ کل ارسال دریافت شده</span>
                                    </div>
                                </div>
                                <div className="p-4 flex gap-2">
                                    <div className="flex items-center text-sm justify-between w-full">
                                        <span className="text-gray-400">تاریخ:</span>
                                        <span>{`از ${timePeriod?.[0] ? timePeriod?.[0] : "ابتدا"} تا ${timePeriod?.[1] ? timePeriod?.[1] : "کنون"}`}</span>
                                    </div>
                                </div>
                            </div>
                            :
                            <Skeleton height={144} className="!rounded-xl" />
                    }
                    {
                        sales
                            ?
                            <div className="bg-white dark:bg-black rounded-xl border border-gray-100">
                                <div className="p-4 flex gap-2 border-b-solid border-b-gray-100 border-b-2">
                                    <div className="bg-gray-50 rounded-full w-14 h-14 flex justify-center items-center">
                                        <TbMapDiscount className="text-primary-color" />
                                    </div>
                                    <div className="flex flex-col gap-1">
                                        <span className="font-bold text-lg">{amortizedDiscountShipping && numberWithCommas(amortizedDiscountShipping)} ریال</span>
                                        <span className="text-sm text-gray-400">مبلغ کل تخفیف ارسال</span>
                                    </div>
                                </div>
                                <div className="p-4 flex gap-2">
                                    <div className="flex items-center text-sm justify-between w-full">
                                        <span className="text-gray-400">تاریخ:</span>
                                        <span>{`از ${timePeriod?.[0] ? timePeriod?.[0] : "ابتدا"} تا ${timePeriod?.[1] ? timePeriod?.[1] : "کنون"}`}</span>
                                    </div>
                                </div>
                            </div>
                            :
                            <Skeleton height={144} className="!rounded-xl" />
                    }


                </div>
            </WhiteBoard>

        </>
    )
}